import { setPageStateById } from '../PageContext';

export const setCustomTitle = (setState: setPageStateById) => (customTitleTId: string) => {
  setState('SET_PAGE_TITLE', (s) => ({
    ...s,
    customTitleTId,
  }));
};
